import React from 'react'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  fullWidth?: boolean
}

export function Input({ label, error, fullWidth = false, className = '', ...props }: InputProps) {
  const widthStyle = fullWidth ? 'w-full' : ''
  const isReadOnly = props.readOnly || props.disabled

  return (
    <div data-component-name="Input" className={`${widthStyle}`}>
      {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
      <input
        className={`
          px-4 py-3
          border border-gray-300
          rounded-lg
          focus:outline-none
          focus:ring-2
          focus:ring-primary
          focus:border-transparent
          transition-all duration-200
          ${error ? 'border-danger' : ''}
          ${isReadOnly ? 'bg-gray-50 text-gray-600 cursor-not-allowed' : ''}
          ${widthStyle}
          ${className}
        `}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-danger">{error}</p>}
    </div>
  )
}
